import {PollResponsePayload} from '../../../models/api';

export default [
  {
    id: 1,
    topic: 'Меняйте "Пятёрочку" вместе с нами',
    startDate: '2020-08-18',
    endDate: '2020-10-29',
    typeId: 1,
    typeName: 'Опрос',
    statusId: 2,
    statusName: 'Активный',
    numberParticipants: 1000,
    isPassed: false,
  },
  {
    id: 2,
    topic: 'Меняйте "Пятёрочку" вместе с нами (прошел)',
    startDate: '2020-08-18',
    endDate: '2020-10-29',
    typeId: 1,
    typeName: 'Опрос',
    statusId: 2,
    statusName: 'Активный',
    numberParticipants: 1000,
    isPassed: true,
  },
  {
    id: 3,
    topic: 'Меняйте "Пятёрочку" вместе с нами (завершен)',
    startDate: '2020-08-18',
    endDate: '2020-08-29',
    typeId: 1,
    typeName: 'Опрос',
    statusId: 3,
    statusName: 'Завершен',
    numberParticipants: 1000,
    isPassed: false,
  },
  {
    id: 3,
    topic: 'Меняйте "Пятёрочку" вместе с нами (прошел и завершен)',
    startDate: '2020-08-18',
    endDate: '2020-08-29',
    typeId: 1,
    typeName: 'Опрос',
    statusId: 3,
    statusName: 'Завершен',
    numberParticipants: 1000,
    isPassed: true,
  },
  {
    id: 5,
    topic: 'Помогите сделать Кировский лучше',
    startDate: '2020-07-10',
    endDate: '2020-11-01',
    typeId: 2,
    typeName: 'Голосование',
    statusId: 2,
    statusName: 'Активный',
    numberParticipants: 1000,
    isPassed: false,
  },
  {
    id: 6,
    topic: 'Помогите сделать Кировский лучше',
    startDate: '2020-07-10',
    endDate: '2020-11-01',
    typeId: 2,
    typeName: 'Голосование',
    statusId: 2,
    statusName: 'Активный',
    numberParticipants: 1000,
    isPassed: true,
  },
  {
    id: 7,
    topic: 'Сеть магазинов Кировский проводит анкетирование покупателей в целях изучения потребительских предпочтений',
    startDate: '2020-02-18',
    endDate: '2020-02-29',
    typeId: 2,
    typeName: 'Голосование',
    statusId: 3,
    statusName: 'Завершен',
    numberParticipants: 1000,
    isPassed: false,
  },
] as PollResponsePayload;
